const state = {
    currentService: null,
    currentFrom: {},
    entityConfigs: {},
};
const getters = {};
const actions = {};
const mutations = {
    setCurrentService(state, service) {
        state.currentService = service;
    },
    setCurrentFrom(state, from) {
        state.currentFrom = from;
    },
    setEntityConfigs(state, val) {
        state.entityConfigs = val;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
